import {
  IFormInputConfig,
  CSelect,
  CInput,
  CConditional,
  CDate,
  CMultiAdd
} from './types'
import { mixed, string, number, array, object } from 'yup'
import { transform, isEqual } from '@fareye/utils'
import { isObject } from 'formik'

export const getDescendantProp = (obj: any, path: string) => {
  const value = path.split('.').reduce((acc, part) => acc && acc[part], obj)
  if (value) {
    return value
  }
  return null
}

export function getInputInitialValue(val: IFormInputConfig) {
  if (CSelect.includes(val.type)) {
    return val.value || null
  } else if (CInput.includes(val.type)) {
    return val.value || ''
  } else if (CConditional.includes(val.type)) {
    return val.value || false
  } else if (CDate.includes(val.type)) {
    return {
      startDate: new Date(),
      endDate: new Date()
    }
  } else if (CMultiAdd.includes(val.type)) {
    return []
  }
}

export function getValidationValue(val: IFormInputConfig) {
  if (val.validation) {
    const errorMessage = val.error ? val.error : `Required`
    switch (val.validation) {
      case 'required':
        return mixed().required(errorMessage)
      case 'email':
        return string().email(errorMessage)
      case 'phone':
        return number()
          .min(1111111111, errorMessage)
          .max(9999999999999, errorMessage)
      case 'regex':
        return string().matches(
          val.regex ? new RegExp(val.regex) : new RegExp('[^]+'),
          errorMessage
        )
      case 'url':
        return string().transform(value => value && value.trim() === '' ? null : value).nullable().url(errorMessage)
      default:
        return mixed()
    }
  }
}

export function multiAddValidation(val: IFormInputConfig) {
  if (val.validation) {
    const mutliValidSchema: any = {}
    ;(val.options as IFormInputConfig[]).forEach(ele => {
      mutliValidSchema[ele.formKey] = getValidationValue(ele)
    })
    return array().of(object().shape(mutliValidSchema))
  }
  return mixed()
}

//NOTE: Use this function to find the difference between two object keys.
export function differenceBetweenObjects(object: any, base: any) {
  function changes(object: any, base: any) {
    return transform(object, function(result: any, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] =
          isObject(value) && isObject(base[key])
            ? changes(value, base[key])
            : value
      }
    })
  }
  return changes(object, base)
}

export function isTimeRemaining(timer: number) {
  let latestTime = new Date().getTime()
  let localStorageTime = localStorage.getItem('disableTime')
  let remainingTime
  if (!localStorageTime) {
    return false
  } else {
    remainingTime = latestTime - Number(localStorageTime)
  }
  if (timer > remainingTime) {
    return true
  }
}
